'use strict';

angular.module('atex.dam').factory('DamPreviewModalController',
['$rootScope', '$modal','$q','DamService',

  function($rootScope, $modal, $q, DamService) {
    return {
      create: function(props) {
        var modalScope = $rootScope.$new(true);
        _.extend(modalScope, props);

        if (modalScope.inputTemplate==='p.DamVideo') {
          DamService.getHighLightedEntry(modalScope.id, "").then(function(objComplete){
            atex.dam.AngularUtils.fixUrls(objComplete.data);
            modalScope.currentWebmUrl = objComplete.data.aspects.contentData.data.webmUrl;
            modalScope.currentMp4Url = objComplete.data.aspects.contentData.data.mp4Url;
            modalScope.thumbUrl = objComplete.data.aspects.contentData.data.thumbUrl;
          }).then(null, function(error) {
            console.log('ERROR: getHighLightedEntry:', error);
          });
        }
        var modal = $modal({
          show: true,
          scope: modalScope,

          template: 'views/dam-modal.html',
          modalClass: 'confirm-modal ng-cloak dam-modal-full-img',
          backdrop: 'static',
          keyboard: false
        });

        modalScope.verified = (modalScope.confirm !== true);

        var deferred = $q.defer();

        var destroyModal = function() {
          modal.then(function(modalEl) {
            modalEl.on('hidden.bs.modal', function() {
              modalScope.$destroy();
              angular.element(this).remove(); // To remove completely the modal div from DOM
            });

            modalEl.modal('hide');
          });
        };

        modalScope.doCancel = function(button) {
          if (button || modalScope.inputTemplate!=='p.DamVideo') {
            destroyModal();
            deferred.resolve(false);
          }
        };

        return deferred.promise;
      }
    };
  }
]);
